import BaseModel from '../core/BaseModel'
export default class UsersModel extends BaseModel {

    constructor() {
        super({ 
                name: "users",
                tableName: 'core_user', 
                label: "Quản lý người dùng"
            }, 
            {
            // stt: {
            //     name: "stt",
            //     label: "STT",
            //     type: "Computed",
            //     computed: (data, index) => {
            //         data.stt = index + 1;
            //     }
            // },
            id: { 
                name: 'id', 
                type: "String", 
                label: 'ID', 
                primaryKey: true,
                display: false
            },
            full_name: { 
                name: 'full_name', 
                type: "String", 
                label: 'Tên tài khoản', 
                sortable: true,
                width: 15,
                filter: { type: 'input',  match: 'custom'}
            },
            phoneNumber: { 
                name: 'phoneNumber', 
                type: "String", 
                label: 'Số điện thoại', 
                width: 15,
                sortable: true,
                filter: { type: 'input',  match: 'contains'},
                computed: (data) => {
                    var phoneConvert = (data.phone_number !== undefined && data.phone_number !== null) ? data.phone_number :  '';
                    data.phoneNumber = phoneConvert.replace('+84', '0');
                }
            },
            roleName: { 
                name: 'roleName', 
                type: "String", 
                label: 'Quyền truy cập', 
                sortable: true,
                width: 13,
                filter: { type: 'input',  match: 'custom'},
                computed: (data) => {
                    if (data.user_role != undefined && data.user_role != null && data.user_role.roles != undefined 
                        && data.user_role.roles != null  &&  data.user_role.roles.name != undefined) {
                        data.roleName = data.user_role.roles.name;
                    }
                }
            },
            organization: { 
                name: 'organization', 
                label: 'Đơn vị của tài khoản',
                class: 'center',
                type: "String",
                width: 14,
                filter: { type: 'input',  match: 'custom'},
                sortable: true,
                computed: (data) => {
                    if (data.organization_account != undefined && data.organization_account != null && data.organization_account.organization != undefined 
                        && data.organization_account.organization != null  &&  data.organization_account.organization.name != undefined) {
                        data.organization = data.organization_account.organization.name;
                    }
                }
            },
            organizationParent: { 
                name: 'organizationParent', 
                label: 'Đơn vị cấp cha',
                class: 'center',
                type: "String",
                width: 14,
                filter: { type: 'input',  match: 'custom'},
                sortable: true,
                computed: (data) => {
                    if (data.organization_account != undefined && data.organization_account != null && data.organization_account.organization != undefined 
                        && data.organization_account.organization != null  &&  data.organization_account.organization.organization_parent != undefined
                        && data.organization_account.organization.organization_parent != null && data.organization_account.organization.organization_parent.name != undefined) {
                        data.organizationParent = data.organization_account.organization.organization_parent.name;
                    }
                }
            },
            level: { 
                name: 'level', 
                type: "String", 
                label: 'Cấp bậc', 
                width: 10,
                sortable: true,
                filter: { type: 'input',  match: 'custom'},
                computed: (data) => {
                    if (data.user_level != undefined && data.user_level != null && data.user_level.name != undefined) {
                        data.level = data.user_level.name;
                    }
                }
            },
            enabled: {
                name: 'enabled', label: 'Trạng thái hoạt động', type: "Selection",  dataType: 'Label',  class: 'center', width: 15,
                options: [{ value: 1, label: 'Đang hoạt động'}, { value: 0, label: 'Ngưng hoạt động'}],
                filter: { type: 'select', display: false, optionLabel: 'label', optionKey: 'value', match: 'equals' },
                computed: (data) => {
                    data.enabled = data.is_enabled ? 1 : 0;
                }
            },

            representative: {
                name: 'representative', label: 'Người đại diện', type: "Selection", dataType: 'Label', class: 'center disabled-opacity', width: 15, disabled: true,
                options: [{ value: 1, label: 'Có'}, { value: 0, label: 'Không'}],
                filter: { type: 'select',  display: false, optionLabel: 'label', optionKey: 'value', match: 'equals' },
                computed: (data) => {
                    data.representative = data.is_representative ? 1 : 0;
                }
            },
            user_level_id: {
                refs: 'user_type phone_number is_representative is_management_units is_enabled user_level { name } user_role { roles { name } } organization_account { organization { name organization_parent { name } } }',
                display: false
            }
        },)
    }

}